export enum RelationshipType {
	"Unknown" = 0,
	"Exclusive: Competitor(s)",
	"Exclusive: M&A",
	"Competitive: Select Vendors",
	"Competitive: Wide Open",
}
